import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import React from 'react';

import { Typography } from '@/shared/components/atoms';

import CheckMarkWithoutBG from '~/images/shared/CheckMarkWithoutBG.svg';

const PrintHeader: React.FC<{ successVariant: boolean }> = ({
  successVariant,
}) => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col items-center'>
      {successVariant && (
        <div className='mb-32 flex h-64 w-64 items-center justify-center rounded-full bg-secondary-90 text-green-300'>
          <CheckMarkWithoutBG width='30' height='30' />
        </div>
      )}
      <Typography
        variant='h2'
        weight='semiBold'
        className={classNames('text-center', successVariant ? 'mb-8' : 'mb-16')}
      >
        {t(
          successVariant
            ? 'Your Field is created successfully'
            : 'Print QR Code'
        )}
      </Typography>
      <Typography
        className=' max-w-[392px] text-center text-surface-10'
        weight='medium'
      >
        {t(
          'Print the QR code ID now to hang it in the field for easy scanning and immediate access to log operations via the Field app.'
        )}
      </Typography>
    </div>
  );
};

export default PrintHeader;
